import { useQuery } from '@tanstack/react-query';

import ExternalApiService from '../services/ExternalService/ExternalApiService';
import { type DashboardResponse } from '../services/types';
import { DISABLE_CACHE_STALE_TIME } from '../utils/constants';

const fetchDashboardDetails = async (): Promise<DashboardResponse> => {
  const { data } = (await ExternalApiService.getDashboardDetails()) as {
    data: DashboardResponse;
  };

  return data;
};

const useGetDashboardDetails = () =>
  useQuery<DashboardResponse>({
    queryKey: ['DASHBOARD_DETAILS'], // Unique query key
    queryFn: fetchDashboardDetails, // Function to fetch data
    staleTime: DISABLE_CACHE_STALE_TIME,
    refetchOnWindowFocus: false,
  });

export default useGetDashboardDetails;
